import _ from 'lodash';
// import store from '../vuex/store';

export const _isGroup = (data) => {
    return !!_.get(data, 'group_id') && !_.get(data, 'content_id');
}

export const isGroup = (data) => {
    return _isGroup(data) && _.get(data, 'type') === 1
}

export const isMenu = (data) => {
    return !!_.get(data, 'content_id');
}

export const isApp = (data) => {
    return _isGroup(data) && _.get(data, 'type') === 2;
}

export const getIconImg = (data) => {
    let icon = _.get(data, 'icon');
    return icon && icon.image;
}

export const getIconFont = (data) => {
    let icon = _.get(data, 'icon');
    return icon && icon.iconfont;
}

export const getIconStyle = (data, line) => {
    let color = _.get(data, 'icon.color');

    if(color) {
        if(line) {
            return { color: color, "border-color": color };
        } else {
            return { color: '#FFF', "border-color": color, "background-color": color };
        }
    }
}

export const isMainMenu = (type, param1, param2) => {
    // let type = this.currentPageType;
    // let query = this.currentPageQuery;
    // let menuId = _.get(query, 'menuId');
    // let pageId = _.get(query, 'pageId');
    let prop = '';
    let menus = _.get(this, '$store.state.menus');

    if(type === 'app') {
        prop = 'group_id';
        let idx = _.findIndex(menus, m => {
            return m && param1 && _.get(m, 'group_id') == param1;
        });

        if(idx >= 0) return true;
    } else if(type === 'page') {
        prop = 'content_id';
        let idx = _.findIndex(menus, m => {
            return m && param1 && _.get(m, 'content_id') == param1;
        });

        if(idx >= 0) return true;
    } else if(type === 'jpage') {
        // prop = 'page_code';
        let idx = _.findIndex(menus, m => {
            return m && param1 && _.get(m, 'page.page_code') === param1;
        });

        if(idx >= 0) return true;
    } else if(type === 'fadd' || type === 'fdatas' || type === 'fdetail') {
        let idx = _.findIndex(menus, m => {
            let isMain =  m && param1 && _.get(m, 'form.form_code') === param1;

            if(param2) {
                isMain = isMain && _.get(m, 'view.form_view_code') === param2;
            }

            return isMain;
        });

        if(idx >= 0) return true;
    }

    return false;
}

export const isMainMenuMix = (type, query) => {

    let param1 = "";
    let param2 = "";

    if(type === 'app') {
        param1 = _.get(query, "menuId");
    } else if(type === 'page') {
        param1 = _.get(query, "_mi") || _.get(query, "menuId");
    } else if(type === 'jpage') {
        param1 = _.get(query, "_pc") || _.get(query, "pageCode");
    } else if(type === 'fadd' || type === 'fdatas' || type === 'fdetail') {
        param1 = _.get(query, "_fc") || _.get(query, "formCode");
        param2 = _.get(query, "_vc") || _.get(query, "viewCode");
    }

    return isMainMenu(type, param1, param2);
}

export default {
    _isGroup,
    isGroup,
    isMenu,
    isApp,
    getIconImg,
    getIconFont,
    getIconStyle,
    isMainMenu,
    isMainMenuMix
}
